import _ from 'lodash';
import * as reducer from './reducers';
import { COMMON } from './route-constants';
import routes from './routes';

import wrapper from './wrapper';

// These needs the '/' before it because of an odd bug in react-isomorphic-render
// Around adding cookies to the request
const CATALOG_URL_PREFIX = '/catalog:/';
const BASE_URL_PREFIX = '/base:/';

export default {
  reducer,
  routes,
  wrapper,
  error: (error, { path, redirect, url }) => {
    // Not authenticated
    if (error.status === 401 && path !== '/login') {
      return redirect(`/login?redirect_to=${url}`);
    } else if (error.message === COMMON.PAGE_ERRORS.PAGE_NOT_FOUND || error.status === 404) {
      return redirect('/404');
    } else if (error.status === 403) {
      return redirect('/unauthorized');
    } else if (path !== '/error') {
      // Only redirect if production for debugging
      if (process.env.NODE_ENV === 'production') {
        console.error('Error:', { path, error, url }); // eslint-disable-line
        return redirect('/error');
      }
    }

    // Unknown error.. keep trowing
    console.error('Error:', { path, error }); // eslint-disable-line
    throw error;
  },
  http: {
    request: (request) => {
      if (request.url.indexOf(sharedEnv.STOREFRONT_API_URL) === 0
          || request.url.indexOf(sharedEnv.CATALOG_API_URL) === 0
          || request.url.indexOf(sharedEnv.BASE_API_URL) === 0
          || request.url.indexOf(sharedEnv.GF_ECOM_SERVER) === 0
      ) {
        request.withCredentials();
      }
    },

    url: (requestPath) => {
      if (sharedEnv.USE_DEV_PROXY === 'true' && sharedEnv.DEV_PROXY_URL) {
        const path = requestPath.replace(/\/(\w+):\//, '');
        return `${sharedEnv.DEV_PROXY_URL}${path}`;
      } else if (requestPath.match(CATALOG_URL_PREFIX)) {
        return _.replace(requestPath, CATALOG_URL_PREFIX, sharedEnv.CATALOG_API_URL);
      } else if (requestPath.match(BASE_URL_PREFIX)) {
        return _.replace(requestPath, BASE_URL_PREFIX, sharedEnv.BASE_API_URL);
      } else if (requestPath.match('^/(ecom|gfcore|user)')) {
        return `${sharedEnv.GF_ECOM_API_URL}${requestPath}`;
      }

      // Default to shop
      return `${sharedEnv.BASE_API_URL}${requestPath}`;
    },

    error: (error, { path, redirect, url }) => {
      // Not authenticated
      if (error.status === 401 && path !== '/login') {
        return redirect(`/login?redirect_to=${url}`);
      }

      // Log error to heroku ?
      if (process.env.NODE_ENV !== 'production') {
        console.error('Error at http:', { path, error, url }); // eslint-disable-line
      }

      throw error;
    },
  },
};



// WEBPACK FOOTER //
// ./app/react-isomorphic-render.js